<!--#region vue BO mission-->
<ng-container *ngIf="calculatorService?.Mission?.globalInformationGroup && calculatorService?.Mission?.globalInformationGroup?.ShowCalculGroup else ElseGlobalInformationGroup">
  <ng-container *ngTemplateOutlet="GroupView; context:{group:calculatorService?.Mission?.globalInformationGroup, isGlobal:true, index:-1}"></ng-container>
</ng-container>
<ng-template #ElseGlobalInformationGroup>
  <ng-container *ngIf="calculatorService?.Mission?.globalInformationGroup?.Amount">
    <ng-container *ngTemplateOutlet="GroupObligations; context:{group:calculatorService?.Mission?.globalInformationGroup, index:-1}"></ng-container>
  </ng-container>
</ng-template>

<ng-container *ngFor="let group of calculatorService?.Mission?.Groups; let iGroup = index">
  <ng-container *ngTemplateOutlet="GroupView; context:{group:group, index:iGroup, isGlobal:false}"></ng-container>
</ng-container>
<!--#endregion-->
<!--#region TEMPLATE BO mission-->
<ng-template #GroupView let-group="group" let-iGroup="index" let-isGlobal="isGlobal">
  <div class="row mission-group position-relative" [ngClass]="{'group-locked': group.locked, 'closed': !group.Visible}">
    <div class="col-12 d-flex py-1">

      <i *ngIf="!isGlobal && !group.Visible" class="far fa-plus-square q-c-danger q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? true : 'collapse'" [attr.data-target]="'#collapse' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapse' + iGroup"
         (click)="calculatorService.ToggleGroup(group, true);"></i>
      <i *ngIf="!isGlobal && group.Visible" class="far fa-minus-square q-c-success q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? 'collapse' : false" [attr.data-target]="'#collapse' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapse' + iGroup"
         (click)="calculatorService.ToggleGroup(group, false);"></i>

      <div class="align-items-center q-bold title-container">
        <span [title]="group.Label">{{group.Label}}</span>
        <span class="q-c-primary col-auto px-1 title-info-circle" *ngIf="group.Description" [title]="group.Description"><i class="fas fa-info-circle"></i></span>
      </div>

      <span class="col-auto px-1 d-flex align-items-center" *ngIf="group.Amount">
        <button class="w-100 rounded-button q-dark-secondary">{{group.Amount | money}}</button>
      </span>

    </div>

    <div [id]="'collapse' + iGroup" class="mission-question mx-3 collapse mt-2 mb-3 col" [ngClass]="[group.Visible || isGlobal ? 'show': '']">
      <ng-container *ngIf="(group.Visible || isGlobal) || group.PreLoadVisibility">
        <ng-container *ngFor="let question of group.Questions; let iQuestion = index; let last = last">
          <ng-container *ngIf="question.Properties.length > 0 ||(!isGlobal || iQuestion == 0)">
            <div class="row">
              <div class="col col-lg-7 col-xl-5 d-flex align-items-center">
                <i *ngIf="!isGlobal && !question.Visible" class="far fa-plus-square q-c-danger q-pointer d-flex align-items-center"
                   [attr.data-toggle]=" question.Visible ? true : 'collapse'" [attr.data-target]="'#collapseQuest' + iGroup + '-' + iQuestion"
                   aria-expanded="true" [attr.aria-controls]="'#collapseQuest' + iGroup + '-' + iQuestion"
                   (click)="calculatorService.ToggleQuestion(question, true);"></i>
                <i *ngIf="!isGlobal && question.Visible" class="far fa-minus-square q-c-success q-pointer d-flex align-items-center"
                   [attr.data-toggle]=" question.Visible ? 'collapse' : false" [attr.data-target]="'#collapseQuest' + iGroup + '-' + iQuestion"
                   aria-expanded="true" [attr.aria-controls]="'#collapseQuest' + iGroup + '-' + iQuestion"
                   (click)="calculatorService.ToggleQuestion(question, false);"></i>
                <div class="title-container">
                  <span [title]="question.Label">{{question.Label}}</span>
                  <span class="q-c-primary col-auto title-info-circle" *ngIf="question.Description" [title]="question.Description"><i class="fas fa-info-circle"></i></span>
                </div>
              </div>
              <div *ngIf="question.Amount" class="col-5 col-sm-3 col-lg-2 col-xl-1 q-bold q-text-m" style="text-align: end;">{{question.Amount | money}}</div>

              <div [id]="'collapseQuest' + iGroup + '-' + iQuestion" class="col-12 mb-3 collapse" [ngClass]="{'show': question.Visible || isGlobal}">
                <ng-container *ngIf="question.Visible || isGlobal || question.PreLoadVisibility">
                  <ng-container *ngFor="let prop of question.Properties; let iProp">
                    <div class="row justify-content-end mt-1">
                      <div class="ml-0 ml-sm-2 mr-auto ml-md-5 col-5 col-md-4 col-lg-3 col-xl-2 d-flex align-items-center">
                        <label id="{{prop?.Value.MainLabel?.ID}}" class="q-bo-label m-0">{{prop.Value.MainLabel.Value}} :</label>
                      </div>
                      <div class="col d-flex align-items-center">
                        <q-dynamictag class="d-flex" style="min-width: 200px" [Model]="calculatorService.bObjectModel" [item]="prop.Value"></q-dynamictag>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #GroupObligations let-group="group" let-iGroup="index">

  <div class="row mission-group position-relative" [ngClass]="{'closed': !group.Visible}">
    <div class="col-12 d-flex py-1">

      <i *ngIf="!group.Visible" class="far fa-plus-square q-c-danger q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? true : 'collapse'" [attr.data-target]="'#collapseObligationGroup' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapseObligationGroup' + iGroup"
         (click)="calculatorService.ToggleGroup(group, true);"></i>
      <i *ngIf="group.Visible" class="far fa-minus-square q-c-success q-pointer d-flex align-items-center"
         [attr.data-toggle]=" group.Visible ? 'collapse' : false" [attr.data-target]="'#collapseObligationGroup' + iGroup"
         aria-expanded="true" [attr.aria-controls]="'#collapseObligationGroup' + iGroup"
         (click)="calculatorService.ToggleGroup(group, false);"></i>

      <div class="align-items-center q-bold title-container">
        <span title="Obligations non affectées à une question">Obligations non affectées à une question</span>
        <span class="q-c-primary col-auto px-1 title-info-circle" title="ensemble des obligations générées mais non affectées à une question en particulier"><i class="fas fa-info-circle"></i></span>
      </div>

      <span class="col-auto px-1 d-flex align-items-center" *ngIf="group.Amount">
        <button class="w-100 rounded-button q-dark-secondary">{{group.Amount | money}}</button>
      </span>
    </div>

    <div [id]="'collapseObligationGroup' + iGroup" class="mission-question mx-3 collapse mt-2 mb-3 col" [ngClass]="[group.Visible ? 'show': '']">
      <ng-container *ngIf="group.Visible || group.PreLoadVisibility">
        <ng-container *ngFor="let question of group.Questions; let iQuestion = index; let last = last">
          <ng-container *ngIf="question.Amount && iQuestion > 0">
            <div class="row">
              <div class="col col-lg-7 col-xl-5 d-flex align-items-center">
                <i class="far fa-plus-square q-c-danger invisible d-flex align-items-center"></i>

                <div class="title-container">
                  <span [title]="iQuestion == 1 ? 'Obligations manuelles' : iQuestion == 2 ? 'Obligations automatiques' : ''">{{iQuestion == 1 ? 'Obligations manuelles' : iQuestion == 2 ? 'Obligations automatiques' : ''}}</span>
                  <span class="q-c-primary col-auto title-info-circle" [title]="iQuestion == 1 ? 'Obligations générées manuellement' : iQuestion == 2 ? 'Obligations générées depuis le plan de charge mais non rattachées à une question' : ''"><i class="fas fa-info-circle"></i></span>
                </div>
              </div>
              <div *ngIf="question.Amount" class="col-5 col-sm-3 col-lg-2 col-xl-1 q-bold q-text-m" style="text-align: end;">{{question.Amount | money}}</div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

</ng-template>
<!--#endregion-->
